import React ,{ useState, useEffect} from "react";
import {Tag, Table, Button} from "antd";
import { ExportOutlined } from "@ant-design/icons";
import { isEmpty } from "lodash";
import htmlParser from "html-react-parser";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { Typography } from 'antd';
const { Text } = Typography;


const BreakdownByType = (props) => {
    const { t, statsData, requestData, detailsBoxTitle } = props; // eslint-disable-line

    //for export 
        const [groupStatsData,setGroupStatsData] = useState([]);

    const sum = (statsData.alert_type).reduce((sumvalue, currentValue) => {
        return sumvalue + parseInt(currentValue.count);
    }, 0);
    useEffect(() => {
            const data = Object.keys(statsData.alert_type).map((key) => ({
                key,
                sitename: statsData.alert_type[key]?.sitename,
                alert_type: statsData.alert_type[key]?.alert_type,
                count: statsData.alert_type[key]?.count,
                percentage: Math.round(statsData.alert_type[key]?.count/sum*100)
              }))
          
            //To preserve the correct order, extract keys, sort them manually, and map values correctly
            setGroupStatsData(Object.values(data).sort((a, b) => a.sitename.localeCompare(b.sitename)));
        }, [statsData, sum]);


  function fitToColumn(arrayOfArray) {
    // get maximum character of each column
    return arrayOfArray[0].map((a, i) => ({ wch: Math.max(...arrayOfArray.map(a2 => a2[i] ? a2[i].toString().length : 0)) }));
}

  const exportDataToExcel = (data, fileName = "alert_statistics_by_alert_type.xlsx") => {
          
           const formattedData = [];
   
           
           // Header row
           
              formattedData.push(["Site Name", "Alert Type", "Count"]);
              data.forEach((record) => {             
                  formattedData.push([record.sitename, record.alert_type, record.count]);  
              });
        
   
           const ws = XLSX.utils.aoa_to_sheet(formattedData);
           const wb = XLSX.utils.book_new();
           XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
         
           // Adjust column widths for better readability
           ws['!cols'] = fitToColumn(formattedData);
  
           // Convert to Blob and Save
           const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
           const blob = new Blob([excelBuffer], {
             type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
           });
         
           saveAs(blob, fileName);
         };
    
    const getDetails = () => (
        <div className="table-v3">
            <div className="ant-table ant-table-small">
                <div className="ant-table-title">
                    <div className="custom-table--header d-flex justify-content-between align-items-center">
                        <h3 className="table-title">{t(`contents.alerts.${detailsBoxTitle}`)}</h3>                     
                        <Button key="btn_export" type="link"  disabled={isEmpty(groupStatsData)} onClick={() => exportDataToExcel(groupStatsData)}>
                            <div className="d-flex align-items-center">
                                <ExportOutlined style={{ fontSize: "18px" }} /> <div style={{ marginLeft: "4px" }}>Export</div>
                            </div>
                        </Button>
                    </div>
                </div>
                <div className="ant-table-container">
                    <div className="ant-table-content">
                        <Table dataSource={groupStatsData} pagination={false}
                            summary={pageData => {
                                let totalCount = 0;
                        
                                pageData.forEach(({ count }) => {
                                    totalCount += parseInt(count);
                                });
                        
                                return (
                                  <>
                                    <Table.Summary.Row style={{fontWeight: 'bold', color:"red"}}>
                                        <Table.Summary.Cell className="ant-table-cell" width="70%">TOTAL COUNT:</Table.Summary.Cell>
                                        <Table.Summary.Cell>
                                        </Table.Summary.Cell>
                                        <Table.Summary.Cell colSpan={2}>
                                            <Text type="danger">{totalCount}</Text>
                                        </Table.Summary.Cell>
                                    </Table.Summary.Row>
                                  </>
                                );
                              }}
                        >
                        <Table.Column
                            title={t("contents.alerts.sitename")}
                            dataIndex="sitename"
                            key = "sitename"
                            sorter={(a, b) => a.sitename.localeCompare(b.sitename)}
                            width="30%"
                        />
                        <Table.Column
                            title={t("contents.alerts.alert_type")}
                            dataIndex="alert_type"
                            key = "alert_type"
                            sorter={(a, b) => (a.alert_type || "").localeCompare(b.alert_type || "")}
                            render={(alert_type) => (alert_type ? (alert_type !== '' ? htmlParser(alert_type) : <Tag color="error">Empty</Tag>):  <Tag color="error">Empty</Tag>)}
                            width="30%"
                        />
                        <Table.Column
                            title={<div className="text-center">{t("contents.alerts.count")}</div>}
                            dataIndex="count"
                            key="count"
                            sorter={(a, b) => a.count - b.count}
                            width="20%"
                        />
                        <Table.Column
                            title={<div className="text-center">Percentage</div>}
                            dataIndex="percentage"
                            key="percentage"
                            sorter={(a, b) => a.percentage - b.percentage}
                            width="20%"
                        />
                        </Table>
                    </div>
                </div>
            </div>
        </div>
    );

    return getDetails();
};

export default BreakdownByType;
